import React, { Component } from 'react';

class HumidityGauge extends Component {
  getZone(value) {
    const v = Number(value);
    if (v < 25) return { label: 'Very Dry', color: '#E5C07B' };
    if (v < 50) return { label: 'Comfortable', color: '#36BA98' };
    if (v < 75) return { label: 'Humid', color: '#3B82F6' };
    return { label: 'Very Humid', color: '#1E40AF' };
  }

  render() {
    const width = 200;
    const height = 260;
    const clampedValue = Math.max(0, Math.min(100, Number(this.props.value)));
    const zone = this.getZone(clampedValue);

    const tubeX = 70;
    const tubeY = 30;
    const tubeWidth = 30;
    const tubeHeight = 170;
    const tubeRadius = tubeWidth / 2;
    const bulbCx = tubeX + tubeWidth / 2;
    const bulbCy = tubeY + tubeHeight + tubeRadius - 4;
    const bulbR = 26;

    const fillHeight = (clampedValue / 100) * (tubeHeight - 8);
    const fillY = tubeY + tubeHeight - 4 - fillHeight;

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '8px 0',
        }}
      >
        <div
          style={{
            fontSize: '0.95em',
            fontWeight: 'bold',
            color: '#5B5B5B',
            marginBottom: 6,
            fontFamily: 'Arial, Helvetica, sans-serif',
          }}
        >
          {this.props.name}
        </div>
        <svg
          width={width}
          height={height}
          viewBox={`0 0 ${width} ${height}`}
        >
          <defs>
            <linearGradient id='humidityFill' x1='0' y1='1' x2='0' y2='0'>
              <stop offset='0%' stopColor='#1E40AF' />
              <stop offset='33%' stopColor='#3B82F6' />
              <stop offset='66%' stopColor='#36BA98' />
              <stop offset='100%' stopColor='#E5C07B' />
            </linearGradient>
            <linearGradient id='tubeShine' x1='0' y1='0' x2='1' y2='0'>
              <stop offset='0%' stopColor='rgba(255,255,255,0.6)' />
              <stop offset='40%' stopColor='rgba(255,255,255,0.05)' />
              <stop offset='100%' stopColor='rgba(255,255,255,0)' />
            </linearGradient>
            <clipPath id='tubeClip'>
              <rect
                x={tubeX}
                y={tubeY}
                width={tubeWidth}
                height={tubeHeight}
                rx={tubeRadius}
                ry={tubeRadius}
              />
            </clipPath>
          </defs>

          <text
            x={width / 2}
            y={20}
            textAnchor='middle'
            fill='#9299b8'
            fontSize='11'
            fontFamily='Arial, Helvetica, sans-serif'
          >
            100%
          </text>

          {[0, 25, 50, 75].map((tick) => {
            const y = tubeY + tubeHeight - 4 - (tick / 100) * (tubeHeight - 8);
            return (
              <g key={tick}>
                <line
                  x1={tubeX + tubeWidth}
                  y1={y}
                  x2={tubeX + tubeWidth + 8}
                  y2={y}
                  stroke='#9299b8'
                  strokeWidth='1.5'
                />
                <text
                  x={tubeX + tubeWidth + 12}
                  y={y + 4}
                  fill='#9299b8'
                  fontSize='10'
                  fontFamily='Arial, Helvetica, sans-serif'
                >
                  {tick}
                </text>
              </g>
            );
          })}

          <rect
            x={tubeX - 4}
            y={tubeY - 4}
            width={tubeWidth + 8}
            height={tubeHeight + 8}
            rx={tubeRadius + 4}
            ry={tubeRadius + 4}
            fill='#f5f5f7'
            stroke='#c7c9d4'
            strokeWidth='1.5'
          />

          <rect
            x={tubeX}
            y={tubeY}
            width={tubeWidth}
            height={tubeHeight}
            rx={tubeRadius}
            ry={tubeRadius}
            fill='#ffffff'
            stroke='#b8bccd'
            strokeWidth='1'
          />

          <rect
            x={tubeX + 2}
            y={fillY}
            width={tubeWidth - 4}
            height={fillHeight + 4}
            fill='url(#humidityFill)'
            clipPath='url(#tubeClip)'
          />

          <rect
            x={tubeX + 2}
            y={tubeY + 2}
            width={6}
            height={tubeHeight - 4}
            rx={3}
            ry={3}
            fill='url(#tubeShine)'
            clipPath='url(#tubeClip)'
          />

          <circle
            cx={bulbCx}
            cy={bulbCy}
            r={bulbR}
            fill='#1E40AF'
            stroke='#b8bccd'
            strokeWidth='1.5'
          />
          <circle
            cx={bulbCx - 8}
            cy={bulbCy - 8}
            r={6}
            fill='rgba(255,255,255,0.35)'
          />
        </svg>

        <div
          style={{
            marginTop: -8,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              fontSize: '1.6em',
              fontWeight: 'bold',
              color: '#5B5B5B',
              fontFamily: 'Arial, Helvetica, sans-serif',
              lineHeight: 1.1,
            }}
          >
            {clampedValue}%
          </div>
          <div
            style={{
              fontSize: '0.8em',
              fontWeight: 'bold',
              color: zone.color,
              marginTop: 2,
              fontFamily: 'Arial, Helvetica, sans-serif',
            }}
          >
            {zone.label}
          </div>
        </div>
      </div>
    );
  }
}

export default HumidityGauge;
